module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/566c8436a098b4c02fed0cc89795c68e.png";